<template>
  <div class="training-page">
    <!-- 01. 顶部品牌Banner区 (600px) -->
    <section class="banner section" style="padding: 0;">
        <div class="container" style="height: 100%;">
            <div class="grid-2" style="align-items: center; height: calc(600px - 80px);">
                <!-- 左侧内容 -->
                <div>
                    <h1>数字工程师培育：企业数字化与AI能力提升解决方案</h1>
                    <p style="font-size: 18px; color: #2c3f5c; margin-bottom: 20px;">面向央企、国企与行业龙头企业、集团类企业，构建数据与智能能力体系建设，提升数字人才数字工程应用能力。</p>
                    <h2 class="tag">数据治理培训（基础/中高级）</h2>
                    <h2 class="tag">AI 大模型应用实战（基础/中高级）</h2>
                    <h2 class="tag">审计风险管理数字化建设</h2>
                    <h2 class="tag">首席数据官CDO（实践班）高级研修</h2>
                    <h2 class="tag">认证培训（CDGA、CDGP、CDMP）</h2>
                    <h2 class="tag">人社证书培训（AI应用工程师）</h2>
                    <div style="display: flex; gap: 20px;">
                        <a href="#" class="btn-primary">立即咨询 <i class="fas fa-arrow-right" style="margin-left: 8px;"></i></a>
                        <router-link to="/training/corporate-training" class="btn-outline">获取2026年课程目录</router-link>
                    </div>
                </div>
                <!-- 右侧视觉图 (科技风抽象) -->
                <div style="display: flex; justify-content: center; align-items: center;">
                    <div style="display: grid; grid-template-columns: 1fr; gap: 20px; align-items: center;">
                        <div style="width: 100%; max-width: 400px; height: 340px; background: radial-gradient(circle at 30% 40%, #b6d6ff, #1a73e8); border-radius: 30px; box-shadow: 20px 20px 40px rgba(0,50,100,0.2); display: flex; flex-direction: column; align-items: center; justify-content: center; color: white; position: relative; overflow: hidden;">
                            <i class="fas fa-chalkboard-user" style="font-size: 100px; opacity: 0.9; margin-bottom: 20px;"></i>
                            <p style="color: white; font-weight: 500;">实战实训 · 数字现场</p>
                        </div>  

                        <div style=" gap: 20px;">
                            <a href="/training/corporate-training" class="btn-outline">2026年度 数字化工程师培训全年计划（内训 + 外部培训）</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- 02. 培训类型入口区（按需选择入口卡片） -->
    <section class="section">
        <div class="container">
            <h2>按需选择 · 企业学习入口</h2>
            <div class="grid-6" style="grid-template-columns: repeat(3, 1fr);">
                <div class="card">
                    <div class="icon-circle"><i class="fas fa-chart-line"></i></div>
                    <h3>企业内训</h3>
                    <p><strong>课程类型：</strong>企业内训（培训 + 工信部证书）</p>
                    <p><strong>课程名称：</strong>财务数据分析（中高级）</p>
                    <p>课程涉及财务数据分析、投资决策模型、财务数据挖掘、财务价值分析等内容。</p>
                    <p style="font-size:14px; color:#64748b;"><strong>成功案例：</strong>国家能源集团-财务共享中心</p>
                    <router-link to="/training/data-analysis" style="color:#1a73e8; font-weight:500;">查看详情 <i class="fas fa-arrow-right"></i></router-link>
                </div>

                <div class="card">
                    <div class="icon-circle"><i class="fas fa-robot"></i></div>
                    <h3>企业内训</h3>
                    <p><strong>课程类型：</strong>企业内训（培训 + 工信部证书）</p>
                    <p><strong>课程名称：</strong>AI大预言模型实践培训（中高级）</p>
                    <p>课程涉及大语言模型基础、Agent、智能问答、智能数据处理等内容。</p>
                    <p style="font-size:14px; color:#64748b;"><strong>成功案例：</strong>国家电网-信息化相关部门</p>
                    <router-link to="/training/ai-training" style="color:#1a73e8; font-weight:500;">查看详情 <i class="fas fa-arrow-right"></i></router-link>
                </div>

                <div class="card">
                    <div class="icon-circle"><i class="fas fa-database"></i></div>
                    <h3>企业内训</h3>
                    <p><strong>课程类型：</strong>企业内训（培训 + 工信部证书）</p>
                    <p><strong>课程名称：</strong>数据管理分析与治理（中高级）</p>
                    <p>课程涉及数据管理基础、数据分析、数据挖掘、数据治理、数据价值等内容。</p>
                    <p style="font-size:14px; color:#64748b;"><strong>成功案例：</strong>Sensenta- 供应链部门</p>
                    <router-link to="/training/data-management" style="color:#1a73e8; font-weight:500;">查看详情 <i class="fas fa-arrow-right"></i></router-link>
                </div>

                <div class="card">
                    <div class="icon-circle"><i class="fas fa-user-tie"></i></div>
                    <h3>中高管研修</h3>
                    <p><strong>课程名称：</strong>首席数据官CDO（实践班）培训（中高级）</p>
                    <p>课程涉及数据管理基础、数据分析、数据挖掘、数据治理、数据价值等内容。</p>
                    <p style="font-size:14px; color:#64748b;"><strong>成功案例：</strong>工信部联合项目，已经举办15期</p>
                    <router-link to="/training/cdo" style="color:#1a73e8; font-weight:500;">查看详情 <i class="fas fa-arrow-right"></i></router-link>
                </div>

                <div class="card">
                    <div class="icon-circle"><i class="fas fa-flask"></i></div>
                    <h3>AI专项实战</h3>
                    <p><strong>课程名称：</strong>AI 专项实战</p>
                    <p>课程涉及大模型应用、提示词工程、AI agent等内容。</p>
                    <p style="font-size:14px; color:#64748b;"><strong>成功案例：</strong>工信部联合项目，已经举办15期</p>
                    <router-link to="/training/cdo" style="color:#1a73e8; font-weight:500;">查看详情 <i class="fas fa-arrow-right"></i></router-link>
                </div>

                <div class="card">
                    <div class="icon-circle"><i class="fas fa-shield-alt"></i></div>
                    <h3>审计风控实训</h3>
                    <p><strong>课程名称：</strong>审计风控合规（数据|AI）建设</p>
                    <p>课程涉及审计数字化、风险管理数字化、AI审计、大数据风控等。</p>
                    <p style="font-size:14px; color:#64748b;"><strong>成功案例：</strong>工信部联合项目，已经举办15期</p>
                    <router-link to="/training/cdo" style="color:#1a73e8; font-weight:500;">查看详情 <i class="fas fa-arrow-right"></i></router-link>
                </div>

                <div class="card">
                    <div class="icon-circle"><i class="fas fa-calendar-day"></i></div>
                    <h3>2026 计划</h3>
                    <p><strong>课程名称：</strong>2026年度计划</p>
                    <p>226年全年、内训、公开课、联合课程、认证课程安排计划。</p>
                    <p style="font-size:14px; color:#64748b;"><strong>成功案例：</strong>已举办多期</p>
                    <router-link to="/training/corporate-training" style="color:#1a73e8; font-weight:500;">查看详情 <i class="fas fa-arrow-right"></i></router-link>
                </div>
            </div>
            <!-- 查看全部课程入口 -->
            <div style="text-align: center; margin-top: 40px;">
                <router-link to="/training/all-courses" class="btn-primary">查看全部课程 <i class="fas fa-arrow-right" style="margin-left: 8px;"></i></router-link>
            </div>
        </div>
    </section>

    <!-- 03. 重点课程推荐区 -->
    <section class="section">
        <div class="container">
            <h2>重点课程 · 热门推荐</h2>
            <div class="grid-3">
                <div class="card">
                    <span style="background:#1a73e8; color:white; padding:4px 12px; border-radius:30px; font-size:12px;">工信部联合课程</span>
                    <h3 style="margin:16px 0 8px;">首席数据官CDO实践班</h3>
                    <p>适合：公司高层、数据负责人/CIO/IT相关人员，公司业务中高层/业务领域从事数据分析相关人员、或有一定数据从业经验，期望体系化提升数据管理、分析及应用能力，偏向实践的人员。 <br>课程天数： | 3天集训  <br> 认证证书：CDO 证书（国标证书） 颁发机构：工信部电子标准技术研究院 </p>
                    <router-link to="/training/cdo" class="btn-primary" style="padding:8px 24px;">立即报名</router-link>
                </div>
                <div class="card">
                    <span style="background:#1a73e8; color:white; padding:4px 12px; border-radius:30px; font-size:12px;">2026热门课程</span>
                    <h3 style="margin:16px 0 8px;">AI大模型应用实战</h3>
                    <p>适合：公司中高层，IT/业务侧管理人员，业务人员，想掌握一定的AI大模型应数字技能，期望系统性的学习，能够快速入门掌握AI大模型的人员，课程偏向模型及算法开发，偏向实践应用。<br>课程天数：| 5天实战 <br> 认证证书： AI 实践应用证书  颁发机构：工信部教考中心</p>
                    <router-link to="/training/ai-practical" class="btn-primary" style="padding:8px 24px;">立即报名</router-link>
                </div>
                <div class="card">
                    <span style="background:#1a73e8; color:white; padding:4px 12px; border-radius:30px; font-size:12px;">认证课程</span>
                    <h3 style="margin:16px 0 8px;">CDGA数据治理工程师</h3>
                    <p>适合：数据专员、从事数据领域，或者公司推进数字化转型人员，期望能够入门数据领域，了解基本的概念、框架、体系，能够培养人员具备基础的数据素养，能够对数字化转型本质、数字技能有基础掌握人员。<br>课程天数： | 4天精讲 <br> 认证证书： CDGA数据治理工程师|CDGP|CDMP 颁发机构：DAMA 协会</p>
                    <a href="https://mp.weixin.qq.com/s/RNjo2r_LJFIxV0-xMsqKjA?scene=1&click_id=1" class="btn-primary" style="padding:8px 24px;" target="_blank" rel="noopener">立即报名</a>
                </div>
            </div>
        </div>
    </section>

    <!-- 04. 核心课程体系结构区（能力地图）背景浅灰 -->
    <section class="section bg-light" style="padding: 60px 0;">
        <div class="container">
            <h2>核心能力地图 · 四大方向</h2>
            <div class="grid-4">
                <div class="card" style="background: white;">
                    <h3>数字化转型方向</h3>
                    <ul style="list-style: none; padding-left:0; color:#3b4b62;">
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>数字战略与企业架构</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>数字化供应链</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>业财融合与精益</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>数字营销与客户洞察</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>智能决策与分析</li>
                    </ul>
                </div>
                <div class="card" style="background: white;">
                    <h3>数据能力建设方向</h3>
                    <ul style="list-style: none; padding-left:0;">
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>数据治理(DGBOK)</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>数据架构与建模</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>数据质量管理</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>主数据管理</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>数据安全与隐私</li>
                    </ul>
                </div>
                <div class="card" style="background: white;">
                    <h3>AI应用实践方向</h3>
                    <ul style="list-style: none; padding-left:0;">
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>大模型精调与RAG</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>AI agent搭建</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>计算机视觉落地</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>预测性维护</li>
                         <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>大模型实践案例</li>                   
                    </ul>
                </div>
                <div class="card" style="background: white;">
                    <h3>审计与风控方向</h3>
                    <ul style="list-style: none; padding-left:0;">
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>数字化审计</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>风险智能预警</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>大数据审计</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>人工智能审计</li>
                        <li><i class="fas fa-circle" style="font-size: 8px; color:#1a73e8; margin-right:8px;"></i>合规科技</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    <!-- 05. 行业培训解决方案区 -->
    <section class="section">
        <div class="container">
            <h2>行业纵深解决方案</h2>
            <div class="industry-tabs">
                <span class="industry-tab active">央企</span>
                <span class="industry-tab">银行</span>
                <span class="industry-tab">制造</span>
                <span class="industry-tab">能源</span>
                <span class="industry-tab">政府</span>
            </div>
            <div class="grid-3">
                <div class="card">
                    <h3>银行业</h3>
                    <p style="font-size:14px; color:#64748b;">典型问题：数据治理分散、实时风控薄弱</p>
                    <p><strong>推荐课程：</strong>数据治理实战、反欺诈AI、监管报送</p>
                    <a href="#" class="btn-outline" style="padding:8px 20px; font-size:14px;">进入行业专题</a>
                </div>
                <div class="card">
                    <h3>高端制造</h3>
                    <p style="font-size:14px; color:#64748b;">典型问题：设备数据未利用、预测维护缺失</p>
                    <p><strong>推荐课程：</strong>工业大数据、AI质检、数字孪生入门</p>
                    <a href="#" class="btn-outline" style="padding:8px 20px; font-size:14px;">进入行业专题</a>
                </div>
                <div class="card">
                    <h3>能源/电力</h3>
                    <p style="font-size:14px; color:#64748b;">典型问题：数据孤岛、碳追踪复杂</p>
                    <p><strong>推荐课程：</strong>能源数据治理、AI负荷预测、碳资产管理</p>
                    <a href="#" class="btn-outline" style="padding:8px 20px; font-size:14px;">进入行业专题</a>
                </div>
            </div>
        </div>
    </section>

    <!-- 06. 企业内训交付流程区 -->
    <section class="section bg-light" style="padding: 60px 0;">
        <div class="container">
            <h2>内训交付流程 · 五步法</h2>
            <div style="display: flex; justify-content: space-between; gap: 10px; position: relative;">
                <div class="process-step">
                    <div class="icon-circle" style="margin: 0 auto 16px; background:#1a73e8; color:white;"><i class="fas fa-clipboard-list"></i></div>
                    <h4>需求调研</h4>
                    <p style="font-size:14px;">深度访谈+问卷</p>
                    <span class="process-line"></span>
                </div>
                <div class="process-step">
                    <div class="icon-circle" style="margin: 0 auto 16px; background:#1a73e8; color:white;"><i class="fas fa-pencil-ruler"></i></div>
                    <h4>方案设计</h4>
                    <p style="font-size:14px;">定制课程+实战</p>
                    <span class="process-line"></span>
                </div>
                <div class="process-step">
                    <div class="icon-circle" style="margin: 0 auto 16px; background:#1a73e8; color:white;"><i class="fas fa-chalkboard-teacher"></i></div>
                    <h4>课程实施</h4>
                    <p style="font-size:14px;">专家入企/在线</p>
                    <span class="process-line"></span>
                </div>
                <div class="process-step">
                    <div class="icon-circle" style="margin: 0 auto 16px; background:#1a73e8; color:white;"><i class="fas fa-chart-line"></i></div>
                    <h4>成果评估</h4>
                    <p style="font-size:14px;">考试/答辩/报告</p>
                    <span class="process-line"></span>
                </div>
                <div class="process-step">
                    <div class="icon-circle" style="margin: 0 auto 16px; background:#1a73e8; color:white;"><i class="fas fa-hand-holding-heart"></i></div>
                    <h4>持续辅导</h4>
                    <p style="font-size:14px;">课后答疑/复训</p>
                </div>
            </div>
        </div>
    </section>

    <!-- 07. 师资专家阵容区 -->
    <section class="section bg-light" style="padding: 60px 0;">
        <div class="container">
            <h2>实战师资 · 行业专家</h2>
            <div class="grid-4">
                <div class="card" style="text-align:center;">
                    <div class="avatar"><i class="fas fa-user-graduate"></i></div>
                    <h4>张立华</h4>
                    <p style="font-size:14px;">CDMP大师 / 原阿里数据总监</p>
                    <p style="color:#1a73e8;">服务200+企业</p>
                </div>
                <div class="card" style="text-align:center;">
                    <div class="avatar"><i class="fas fa-user-tie"></i></div>
                    <h4>王敏</h4>
                    <p style="font-size:14px;">工信部数字化转型顾问</p>
                    <p style="color:#1a73e8;">服务150+央企</p>
                </div>
                <div class="card" style="text-align:center;">
                    <div class="avatar"><i class="fas fa-user-astronaut"></i></div>
                    <h4>陈一凡</h4>
                    <p style="font-size:14px;">AI大模型实战专家</p>
                    <p style="color:#1a73e8;">主持20+AI项目</p>
                </div>
                <div class="card" style="text-align:center;">
                    <div class="avatar"><i class="fas fa-user-lock"></i></div>
                    <h4>赵卫红</h4>
                    <p style="font-size:14px;">审计风控数字化专家</p>
                    <p style="color:#1a73e8;">四大背景/120+客户</p>
                </div>
            </div>
        </div>
    </section>

    <!-- 08. 成功案例区 -->
    <section class="section">
        <div class="container">
            <h2>成功实践 · 客户案例</h2>
            <div class="grid-2" style="align-items:center;">
                <div>
                    <div style="display:flex; gap:30px; margin-bottom:16px;">
                        <span><i class="fas fa-building" style="color:#1a73e8;"></i> 某国有大行</span>
                        <span><i class="fas fa-users" style="color:#1a73e8;"></i> 500+人培训</span>
                    </div>
                    <p><strong>项目周期：</strong>6个月 (数据治理+AI风控)</p>
                    <p><strong>成果：</strong>通过CDGA认证35人，建模效率提升40%</p>
                </div>
                <div style="background:#dbeafe; border-radius:16px; height:180px; display:flex; align-items:center; justify-content:center; color:#1a73e8;">
                    <i class="fas fa-image" style="font-size:60px;"></i> 培训现场
                </div>
            </div>
            <div class="logo-wall">
                <span>中国银行</span><span>国家能源</span><span>一汽集团</span><span>南方电网</span><span>华润集团</span><span>上汽通用</span>
            </div>
        </div>
    </section>

    <!-- 09. 认证与成果展示区 -->
    <section class="section bg-light" style="padding: 60px 0;">
        <div class="container">
            <h2>权威认证 · 成果鉴证</h2>
            <div class="grid-4">
                <div class="card" style="text-align:center;"><i class="fas fa-scroll" style="font-size:48px; color:#1a73e8;"></i><h4>工信部联合</h4><p>首席数据官研修</p></div>
                <div class="card" style="text-align:center;"><i class="fas fa-certificate" style="font-size:48px; color:#1a73e8;"></i><h4>CDO实践认证</h4><p>企业认可</p></div>
                <div class="card" style="text-align:center;"><i class="fas fa-robot" style="font-size:48px; color:#1a73e8;"></i><h4>AI专业认证</h4><p>工信部人才</p></div>
                <div class="card" style="text-align:center;"><i class="fas fa-database" style="font-size:48px; color:#1a73e8;"></i><h4>数据治理认证</h4><p>CDGA/CDGP</p></div>
            </div>
        </div>
    </section>

    <!-- 10. 培训知识文章区（SEO核心） -->
    <section class="section">
        <div class="container">
            <div class="grid-2">
                <div>
                    <h2>洞见 · 白皮书</h2>
                    <ul style="list-style:none;">
                        <li class="card" style="margin-bottom:16px;"><a href="#" style="font-weight:600;">数据治理赋能企业数字化转型</a><p style="font-size:14px;">摘要：从DG到AI就绪...</p></li>
                        <li class="card" style="margin-bottom:16px;"><a href="#" style="font-weight:600;">央企CDO能力框架建设指南</a><p style="font-size:14px;">摘要：工信部联合课题...</p></li>
                        <li class="card" style="margin-bottom:16px;"><a href="#" style="font-weight:600;">AI大模型在审计中的应用</a><p style="font-size:14px;">摘要：风险预警新范式...</p></li>
                        <li class="card" style="margin-bottom:16px;"><a href="#" style="font-weight:600;">首席数据官(Certified)实践班</a><p style="font-size:14px;">摘要：培养数字化领导者...</p></li>
                        <li class="card"><a href="#" style="font-weight:600;">2025数据治理趋势白皮书</a><p style="font-size:14px;">摘要：体系化治理与AI融合...</p></li>
                    </ul>
                </div>
                <div>
                    <h2>热门标签</h2>
                    <div class="tag-list">
                        <span class="tag">数据治理</span><span class="tag">AI大模型</span><span class="tag">首席数据官</span><span class="tag">审计数字化</span><span class="tag">CDGA认证</span><span class="tag">人社证书</span><span class="tag">数字化转型</span><span class="tag">能源数据</span>
                    </div>
                    <div class="card" style="background:#f0f6ff; margin-top:24px;">
                        <h3>白皮书下载</h3>
                        <p>《企业数字化人才建设蓝皮书》</p>
                        <a href="#" class="btn-primary" style="padding:10px 28px;">免费下载</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- 11. 报名咨询 (简化版 CSS) -->
    <section class="section" style="margin-bottom: 50px;">
        <h2><i class="fa-regular fa-star"></i> 预约咨询 </h2>  
        <div class="p-10 rounded-2xl border border-divider shadow-sm">
            <!-- Section-Title -->
            <div class="text-center max-w-2xl mx-auto">
                <h2 class="text-center text-3xl font-bold text-[#0E1F52]">构建可信、统一的数据治理、AI治理体系，强化数字人才成长梯队</h2>
                <p class="mt-3 text-[#5A5E66]">请留下您的信息，我们将安排资深顾问与您联系</p>
            </div>
            <!-- 预约咨询/在线客服 --> 
            <div class="cta-buttons">
                <a href="#" class="btn-primary" @click.prevent="showModal = true">预约咨询</a>
                <a href="#" class="btn-outline-light">在线客服</a>
            </div>
            <!-- 扫码添加顾问 --> 
            <div class="cta-buttons" @click="showQrCode">
                <a href="#" class="fab fa-weixin btn-primary">  扫码添加顾问</a>
            </div>
            <!-- 致电/发送邮件 -->
            <div style="margin-top: 15px; display: flex; justify-content: center; gap: 20px; flex-wrap: wrap;">
                <span>致电:185-1017-6330</span>
                <span>发送邮件: pmo@gushandata.cn</span>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
    name: 'Training'
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.training-page {
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    background-color: #ffffff;
    color: #1e293b;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
}

/* 主容器宽度1200px，居中，左右留白20px保证移动端舒适 */
.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    width: 100%;
}

/* 模块间距：80px，通过 section 的下边距控制 */
.section {
    margin-bottom: 80px;
}
.section:last-child {
    margin-bottom: 0;
}

/* 通用样式 */
.aia-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
}

/* 背景辅助类 */
.bg-white {
    background-color: #ffffff;
}
.bg-light {
    background-color: #f5f7fa;
}
.bg-primary-blue {
    background-color: #1a73e8;
}

/* 主色调元素 */
.text-primary {
    color: #1a73e8;
}
.btn-primary {
    display: inline-block;
    background-color: #1a73e8;
    color: white;
    font-weight: 600;
    padding: 12px 32px;
    border-radius: 40px; /* 圆润但不过火，保留专业感 */
    border: 1px solid #1a73e8;
    transition: all 0.2s ease;
    text-decoration: none;
    font-size: 16px;
    letter-spacing: 0.3px;
    box-shadow: 0 4px 8px rgba(26,115,232,0.15);
}
.btn-primary:hover {
    background-color: #0e5bbf;
    border-color: #0e5bbf;
    box-shadow: 0 8px 16px rgba(26,115,232,0.25);
}
.btn-outline {
    display: inline-block;
    background-color: transparent;
    color: #1a73e8;
    font-weight: 600;
    padding: 12px 32px;
    border-radius: 40px;
    border: 1px solid #1a73e8;
    transition: all 0.2s ease;
    text-decoration: none;
    font-size: 16px;
}
.btn-outline:hover {
    background-color: rgba(26,115,232,0.04);
    border-color: #0e5bbf;
    color: #0e5bbf;
}

/* 标题尺寸 */
h1 {
    font-size: 42px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.02em;
    margin-bottom: 24px;
    color: #0b1a33;
}
h2 {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 32px;
    letter-spacing: -0.01em;
    color: #0b1a33;
}
h3 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
}
p {
    font-size: 16px;
    color: #475569;
    margin-bottom: 16px;
}

/* 卡片通用设计 */
.card {
    background: white;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.02), 0 4px 12px rgba(0,20,40,0.03);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border: 1px solid rgba(0,0,0,0.02);
}
.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 20px 30px rgba(26,115,232,0.05), 0 6px 14px rgba(0,20,40,0.08);
}

/* 标签组 */
.tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin: 24px 0 28px;
}
.tag {
    background: rgba(26,115,232,0.06);
    color: #1a4c8c;
    padding: 8px 18px;
    border-radius: 40px;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid rgba(26,115,232,0.15);
}

/* 栅格系统 */
.grid-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
}
.grid-3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
}
.grid-4 {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
}
.grid-6 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
}
/* 两列入口实际是3x2，用grid-6适配 */

/* 图标占位圆形 */
.icon-circle {
    width: 56px;
    height: 56px;
    background: linear-gradient(145deg, #e8f0fe, #d4e2fc);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a73e8;
    font-size: 24px;
    margin-bottom: 16px;
}

/* 表单元素 */
.form-group {
    margin-bottom: 16px;
}
input, select {
    width: 100%;
    padding: 14px 18px;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    font-size: 16px;
    background: white;
    transition: 0.2s;
}
input:focus, select:focus {
    border-color: #1a73e8;
    outline: none;
    box-shadow: 0 0 0 3px rgba(26,115,232,0.15);
}

/* 青花瓷纹理（微妙的线条） */
.blue-porcelain-bg {
    background: linear-gradient(125deg, #f0f7ff 0%, #ffffff 100%), repeating-linear-gradient(45deg, rgba(26,115,232,0.02) 0px, rgba(26,115,232,0.02) 2px, transparent 2px, transparent 8px);
    background-blend-mode: overlay;
}

/* 顶部banner定制 */
.banner {
    min-height: 600px;
    display: flex;
    align-items: center;
    background: linear-gradient(145deg, #f5faff, #ffffff, #e6f0ff), repeating-linear-gradient(45deg, rgba(26,115,232,0.02) 0px, rgba(26,115,232,0.02) 20px, transparent 20px, transparent 40px);
    background-blend-mode: overlay;
    border-bottom: 1px solid rgba(26,115,232,0.1);
}

/* 水平连接线 (用于流程) */
.process-step {
    text-align: center;
    position: relative;
}
.process-line {
    position: absolute;
    top: 30px;
    right: -60px;
    width: 100px;
    height: 2px;
    background: linear-gradient(90deg, #1a73e8 20%, #b2d4ff 80%);
    border-radius: 2px;
}
.process-step:last-child .process-line {
    display: none;
}

/* 案例logo墙 */
.logo-wall {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
    justify-content: space-between;
    align-items: center;
    margin-top: 32px;
    opacity: 0.7;
    filter: grayscale(1);
}
.logo-wall span {
    font-size: 18px;
    font-weight: 600;
    color: #3b4b62;
    background: #edf2f9;
    padding: 8px 22px;
    border-radius: 40px;
}

/* 调整部分布局 */
.industry-tabs {
    display: flex;
    gap: 16px;
    margin-bottom: 32px;
    flex-wrap: wrap;
}
.industry-tab {
    padding: 8px 24px;
    background: white;
    border-radius: 40px;
    font-weight: 500;
    border: 1px solid #e0e7ef;
    color: #335;
    cursor: default;
}
.industry-tab.active {
    background: #1a73e8;
    color: white;
    border-color: #1a73e8;
}

/* 师资头像圆形 */
.avatar {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: #c2daf7;
    margin: 0 auto 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a4c8c;
    font-size: 40px;
    font-weight: 300;
    border: 3px solid white;
    box-shadow: 0 8px 16px rgba(0,0,0,0.05);
}

/* 报名咨询模块样式 (与现有变量统一) */
.signup-section {
    padding: 80px 0;
    background-color: #F6F8FC;  /* 与原有 bg-[#F6F8FC] 一致 */
}

.signup-container {
    max-width: 1200px;        /* 对应 max-w-4xl ≈ 896px，取整为960px */
    margin: 0 auto;
    padding: 0 24px;
}

.signup-card {
    background: #ffffff;
    padding: 40px 48px;
    border-radius: 16px;        /* 对应 rounded-2xl (1rem) */
    border: 1px solid #e9edf4;   /* 原 border-divider 需定义，这里给一个浅灰 */
    box-shadow: 0 4px 20px rgba(0,0,0,0.02);
}

.signup-title {
    font-size: 28px;            /* 对应 text-3xl = 1.875rem ≈ 30px，取28px与h2统一 */
    font-weight: 700;
    text-align: center;
    color: #0E1F52;             /* 深靛蓝 */
    margin-bottom: 16px;
}

.signup-subtitle {
    font-size: 18px;            /* 对应 text-lg */
    text-align: center;
    color: #5A5E66;             /* 原描述颜色 */
    margin-bottom: 40px;
}

.signup-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-group.full-width {
    grid-column: span 2;
}

.form-label {
    font-size: 14px;
    font-weight: 500;
    color: #2B2F3A;             /* 墨蓝灰 */
}

.form-input,
.form-select,
.form-textarea {
    width: 100%;
    padding: 12px 16px;         /* 对应 py-3 (0.75rem) px-4 (1rem) */
    border: 1px solid #e9edf4;  /* 分隔线色 */
    border-radius: 6px;         /* rounded-md 默认0.375rem */
    font-size: 16px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
    border-color: #1F3F8F;       /* brand主色 */
    box-shadow: 0 0 0 3px rgba(31,63,143,0.15);
}

.form-textarea {
    resize: vertical;
}

.signup-button {
    width: 100%;
    background-color: #1F3F8F;   /* 品牌蓝 */
    color: white;
    padding: 16px 24px;
    border-radius: 6px;
    font-size: 18px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s, box-shadow 0.2s;
    box-shadow: 0 4px 8px rgba(31,63,143,0.2);
}

.signup-button:hover {
    background-color: #0E1F52;   /* 深靛蓝 */
}

.form-privacy {
    font-size: 12px;
    color: #5A5E66;
    text-align: center;
    margin-top: 8px;
}

.phone-cta {
    text-align: center;
    margin-top: 24px;
}

.phone-link {
    color: #1F3F8F;
    text-decoration: none;
    font-weight: 500;
}

.phone-link:hover {
    text-decoration: underline;
}


/* 底部转化 */
.cta-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
}


.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin: 30px 0;
  flex-wrap: wrap;
}

.qr-code {
  display: inline-block;
  background: white;
  padding: 12px 24px;
  border-radius: 60px;
  margin-top: 20px;
  cursor: pointer;
  color: var(--deep-indigo);
}


.btn-primary {
  display: inline-block;
  background: #1F3F8F;
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}
.btn-primary:hover {
  background: #0e3170;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(31,63,143,0.3);
}

.btn-outline-light {
  background: #EAF0FB;
  color: black;
  border: 1px solid #0e3170;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  transition: 0.3s;
  text-decoration: none;
}
.btn-outline-light:hover {
  background: rgba(255,255,255,0.1);
  border-color: #0e3170;
}



h2 {
    font-size: 28px;
    font-weight: 700;
    color: #0E1F52;
    margin-top: 20px;
    margin-bottom: 20px;
    letter-spacing: -0.01em;
    position: relative;
    display: inline-block;
}

h2:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 3px;
    background-color: #1F3F8F;
    border-radius: 4px;
}



/* 响应式：小屏时两列变一列 */
@media (max-width: 640px) {
    .signup-card {
        padding: 32px 20px;
    }
    .form-row {
        grid-template-columns: 1fr;
        gap: 20px;
    }
    .form-group.full-width {
        grid-column: span 1;
    }
}

</style>
